'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002429 from "./presto.-Agent-View$$anon$29.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dRequest$0024 from "./presto.-Agent-View$-Local-Pje-Office-Sign-Hash-Request$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024 from "./presto.types$-U-R-L$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$28() {
  this.ay4 = null;
  this.axW = null;
  this.axX = false;
  this.ay5 = null;
  this.ay6 = false;
  this.ay9 = null;
  this.ay2 = null;
  this.ay3 = false;
  this.axY = null;
  this.axZ = false;
  this.ay0 = null;
  this.ay1 = false;
  this.ay7 = false;
  this.ay8 = false;
  this.ay4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.ay9 = "LocalPjeOfficeSignHashRequest";
}
export { $c_Lpresto_AgentView$$anon$28 as $c_Lpresto_AgentView$$anon$28 };
$p = $c_Lpresto_AgentView$$anon$28.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$28;
/** @constructor */
function $h_Lpresto_AgentView$$anon$28() {
}
export { $h_Lpresto_AgentView$$anon$28 as $h_Lpresto_AgentView$$anon$28 };
$h_Lpresto_AgentView$$anon$28.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.ay4;
});
$p.M = (function() {
  if ((!this.axX)) {
    this.axW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axX = true;
  }
  return this.axW;
});
$p.O = (function() {
  if ((!this.ay6)) {
    this.ay5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.ay6 = true;
  }
  return this.ay5;
});
$p.E = (function() {
  return this.ay9;
});
$p.t = (function() {
  if ((!this.ay3)) {
    this.ay2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("origin", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("algo", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hashes", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.ay3 = true;
  }
  return this.ay2;
});
$p.N = (function() {
  if ((!this.axZ)) {
    this.axY = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dU$002dR$002dL$0024.$m_Lpresto_types$URL$().fb(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a2o())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.axZ = true;
  }
  return this.axY;
});
$p.Q = (function() {
  if ((!this.ay1)) {
    this.ay0 = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002429.$c_Lpresto_AgentView$$anon$29();
    this.ay1 = true;
  }
  return this.ay0;
});
$p.v = (function() {
  if ((!this.ay8)) {
    this.ay7 = false;
    this.ay8 = true;
  }
  return this.ay7;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee196) => ((p) => \u03b4scrutinee196.cFl(p)))($j_presto$002e$002dAgent$002dView$0024$002dLocal$002dPje$002dOffice$002dSign$002dHash$002dRequest$0024.$m_Lpresto_AgentView$LocalPjeOfficeSignHashRequest$())));
});
var $d_Lpresto_AgentView$$anon$28 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$28, "presto.AgentView$$anon$28", ({
  DP: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$28 as $d_Lpresto_AgentView$$anon$28 };
//# sourceMappingURL=presto.-Agent-View$$anon$28.js.map
